import { request } from "apis/base";

export const storageApi = {
  uploadFile: (file: File, folder: string) => {
    const formData = new FormData();
    formData.append("file", file);
    return request({
      url: "/storage/upload",
      method: "POST",
      data: formData,
      params: { folder },
      headers: { "content-type": "multipart/form-data" },
    });
  },

  getFile: (key: string) =>
    request({
      url: "/storage/file",
      method: "GET",
      params: { key },
      responseType: "blob",
    }),
};
